export const COLOR_DEFAULTS = {
  mainColor: '#4f6ef7',
  textColor: '#f0f4ff',
  labelColor: '#c8d4ff',
};

/** Старые дефолты из схемы Mongo — считаем «не задано» */
const LEGACY = {
  mainColor: new Set(['#dedede', '#DEDEDE']),
  textColor: new Set(['#515a5d', '#515A5D']),
  labelColor: new Set(['#004cff', '#004CFF']),
};

export function resolveTemplateColor(value, key) {
  const fallback = COLOR_DEFAULTS[key];
  if (!value || LEGACY[key]?.has(value)) return fallback;
  return value;
}

export function resolveTemplateColors(template = {}) {
  return {
    mainColor: resolveTemplateColor(template.mainColor, 'mainColor'),
    textColor: resolveTemplateColor(template.textColor, 'textColor'),
    labelColor: resolveTemplateColor(template.labelColor, 'labelColor'),
  };
}
